import React, { useState, useEffect } from 'react'
import { useSwipeable } from 'react-swipeable';
import ScheduleView from '../../ScheduleView';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion, faThumbsUp, faUser, faImage, faCircleInfo, faLock } from '@fortawesome/free-solid-svg-icons';
import { isMobile } from 'react-device-detect';

const CalendarView = ({ screenObj, setScheduleSelection, scheduleSelection, json, handleChangeUserSelections, userSelections, setPage, userGUID, showInfoModal, online, selectedGroupGUID, getSchedule }) => {

    const { windowWidth, windowHeight, optionsBarHeight, statusBarPadding, horizontal } = screenObj;
    const scheduleWidth = horizontal ? windowWidth : windowWidth;
    const scheduleHeight = windowHeight - optionsBarHeight - statusBarPadding;

    const [selectedDate, setSelectedDate] = useState(localStorage.getItem('selectedDate') != null ? parseInt(localStorage.getItem('selectedDate')) : 0);
    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (selectedDate < json.length - 1) setSelectedDate((prev) => prev + 1);
        },
        onSwipedRight: () => {
            if (selectedDate > 0) setSelectedDate((prev) => prev - 1);
        },
        onSwipedDown: () => {
            getSchedule();
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: true // Optional: Allows swipe detection with a mouse
    });

    const weekdayInTZ = (dateStr, tz = "America/Los_Angeles") => {
        const [y, m, d] = dateStr.split("-").map(Number);
        const utcDate = new Date(Date.UTC(y, m - 1, d, 12, 0, 0)); // noon UTC
        return new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone: tz })
            .format(utcDate)
            .toUpperCase();
    };

    useEffect(() => {
        localStorage.setItem('selectedDate', selectedDate)
    }, [selectedDate]);

    return (
        <div className={showInfoModal ? ' blur' : ''}>
            <div className="button-container">
                {json.map((date, dateIndex) => (
                    <button
                        key={dateIndex}
                        style={{ flex: '1 0 48px' }}
                        onClick={() => setSelectedDate(dateIndex)}
                        className={selectedDate === dateIndex ? 'btn selected' : 'btn'}
                    >
                        {weekdayInTZ(date.date, date.timezone)}
                    </button>
                ))}

                <button
                    style={{ flex: '0 0 40px', marginLeft: 10 }}
                    onClick={() => setScheduleSelection(3)} className={scheduleSelection === 3 ? 'btn btn-ranking-3' : 'btn'}>
                    <FontAwesomeIcon icon={faQuestion} />
                </button>
                <button
                    style={{ flex: '0 0 40px', marginRight: 0 }}
                    onClick={() => setScheduleSelection(4)} className={scheduleSelection === 4 ? 'btn btn-ranking-4' : 'btn'}>
                    <FontAwesomeIcon icon={faThumbsUp} />
                </button>
                <button
                    style={{ flex: '0 0 40px', marginRight: 10 }}
                    onClick={() => setScheduleSelection(0)} className={scheduleSelection === 0 ? 'btn btn-primary' : 'btn'}>
                    <FontAwesomeIcon icon={selectedGroupGUID ? faCircleInfo : faLock } />
                </button>

                {isMobile ? <button onClick={() => setPage('options')} className="btn"
                    style={{ flex: '0 0 40px' }}
                >
                    <FontAwesomeIcon icon={faImage} />
                </button> : <></>}
                <button disabled={!online} onClick={() => setPage('user')} className={`btn ${userGUID && online ? 'selected' : ''}`}
                    style={{ flex: '0 0 40px' }}
                >
                    <FontAwesomeIcon icon={faUser} />
                </button>
            </div>
            <div id="exportSourceInnerHTML"
                {...handlers}
                style={{
                    position: 'relative',
                    overflow: 'hidden',
                    touchAction: 'pan-y',
                    width: horizontal ? `${windowWidth}px` : undefined,
                    height: horizontal ? `${scheduleHeight}px` : undefined,
                }}>
                <div
                    id="dayPaneContainer"
                    style={{
                        height: `${scheduleHeight}px`,
                        justifyContent: 'center',
                        display: 'flex',
                        width: '100%',
                    }}>
                    <ScheduleView
                        data={json[selectedDate]}
                        width={scheduleWidth}
                        height={scheduleHeight}
                        scheduleSelection={scheduleSelection}
                        handleChangeUserSelections={handleChangeUserSelections}
                        userSelections={userSelections}
                        showGroupSchedules={selectedGroupGUID !== '' && online}
                    />
                </div>
            </div >
        </div>
    )
}

export default CalendarView;
